import { BaseballLineupPosition } from '@trackman/baseball-shared-components';
import { Hotkeys } from 'constants/Hotkeys';
import { ITagCatcherThrows } from 'interfaces/tagging/ITag';
import { Play } from 'models/tagging/Play';
import React from 'react';
import { CatcherThrowsOption } from '../CatcherThrowsOption/CatcherThrowsOption';
import { EditChip } from '../EditChip/EditChip';
import { CatcherThrowsFlowWrapper, FirstRow, FourthRow, SecondRow, ThirdRow } from './CatcherThrowsFlowStyles';
import BackgroundImage from './images/CatcherThrows.png';

interface IProps {
  play: Play | undefined;
  onPressHotkeyCallback: (value: ITagCatcherThrows, position: string) => void;
  onClickCallback: (value: ITagCatcherThrows, position: string) => void;
  review: boolean;
}

export const CatcherThrowsFlow: React.FC<IProps> = ({ onPressHotkeyCallback, onClickCallback, play, review }) => {
  if (!play) {
    return <></>;
  }

  const getFieldingPlayer = (position: string) => {
    const lineup = play.getPitchingTeamLineup().players;
    const fielder = lineup.find((x) => x.position === position);
    if (fielder) {
      return fielder;
    }
    throw Error(`Player position not found on position: ${position}`);
  };

  const handleOnClickCallback = (position: string, thrownPosition: string) => {
    const fieldingPlayer = getFieldingPlayer(position);
    onClickCallback({ fielder: fieldingPlayer, thrownPosition }, thrownPosition);
  };

  const handleOnPressHotkeyCallback = (position: string, thrownPosition: string) => {
    const fieldingPlayer = getFieldingPlayer(position);
    onPressHotkeyCallback({ fielder: fieldingPlayer, thrownPosition }, thrownPosition);
  };

  return (
    <CatcherThrowsFlowWrapper className={`${review ? 'review' : ''}`} style={{ backgroundImage: `url(${BackgroundImage})` }}>
      {play.isCatcherThrowsSaved && <EditChip />}
      <FirstRow>
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.LeftFielder.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.LeftFielder.hotkeyDisplay}
          value='7'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.LeftField, '7')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.LeftField, '7')}
          displayName='7'
          className='position7'
        />
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.CenterFielder.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.CenterFielder.hotkeyDisplay}
          value='8'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.CenterField, '8')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.CenterField, '8')}
          displayName='8'
        />
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.RightFielder.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.RightFielder.hotkeyDisplay}
          value='9'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.RightField, '9')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.RightField, '9')}
          displayName='9'
          className='position9'
        />
      </FirstRow>
      <SecondRow>
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.ShortStopper.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.ShortStopper.hotkeyDisplay}
          value='6'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.Shortstop, '6')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.Shortstop, '6')}
          displayName='6'
        />
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.SecondBase.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.SecondBase.hotkeyDisplay}
          value='4'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.SecondBase, '4')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.SecondBase, '4')}
          displayName='4'
        />
      </SecondRow>
      <ThirdRow>
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.ThirdBase.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.ThirdBase.hotkeyDisplay}
          value='5'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.ThirdBase, '5')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.ThirdBase, '5')}
          displayName='5'
        />
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.Pitcher.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.Pitcher.hotkeyDisplay}
          value='1'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.Pitcher, '1')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.Pitcher, '1')}
          displayName='1'
        />
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.FirstBase.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.FirstBase.hotkeyDisplay}
          value='3'
          onPressHotkeyCallback={() => handleOnPressHotkeyCallback(BaseballLineupPosition.FirstBase, '3')}
          onClickCallback={() => handleOnClickCallback(BaseballLineupPosition.FirstBase, '3')}
          displayName='3'
        />
      </ThirdRow>
      <FourthRow>
        <CatcherThrowsOption
          hotkeyCode={Hotkeys.CatcherThrow.Catcher.hotkeyCode}
          hotkeyDisplay={Hotkeys.CatcherThrow.Catcher.hotkeyDisplay}
          value='2'
          onPressHotkeyCallback={() => {}}
          onClickCallback={() => {}}
          displayName='2'
          disabled
        />
      </FourthRow>
    </CatcherThrowsFlowWrapper>
  );
};
